import React from "react";
import { Result, Button, message, Modal } from "antd";
import { useMutation } from "react-query";
import { Link, useHistory } from "react-router-dom";
import { setUserInvitation } from "../../../api/user";

const ActivationSelection = (props) => {
  const { createStatus, createdUserDetails, goToFirst } = props;

  const { confirm } = Modal;
  const history = useHistory();

  const showConfirm = () => {
    confirm({
      title: "Activation email sent",
      okText: "Im Done",
      cancelText: "Add a new user",
      icon: null,
      onOk() {
        history.push("/user-manager");
      },
      onCancel() {
        history.push("/user-create");
        goToFirst();
      },
    });
  };

  const { mutateAsync: sendUserInvitation, loading } = useMutation(
    setUserInvitation,
    {
      onSuccess: () => {
        showConfirm();
      },
      onError: (error) => {
        message.error(error?.response?.data?.message);
      },
    },
  );

  const sendPasswordSetEmail = async () => {
    if (createdUserDetails?._id && createdUserDetails?.email) {
      await sendUserInvitation({
        data: {
          user_id: createdUserDetails._id,
          email: createdUserDetails.email,
          password_reset: null,
        },
      });
    } else {
      message.error("User Email not available");
    }
  };

  return (
    <Result
      status="success"
      title={`User Account has been successfully ${
        createStatus ? "created" : "updated"
      }!`}
      subTitle={
        createStatus &&
        process.env?.REACT_APP_PLATFORM_TYPE === "GENERIC" &&
        "Now, Let's send the User Account activation email"
      }
      extra={
        createStatus && process.env?.REACT_APP_PLATFORM_TYPE === "GENERIC"
         ? ([
            <Link to="/user-manager">
              <Button key="buy">Activate Later</Button>
            </Link>,
            <Button
                type="primary"
                key="console"
                onClick={sendPasswordSetEmail}
                loading={loading}
            >
              Activate Now
            </Button>,
          ]) : 
          ([
            <Link to={"/user-manager"} >
              <Button type="primary">I'm Done</Button>
            </Link>
        ])}
    />
  );
};

export default ActivationSelection;
